/* BONHEUR · Barra fija de la ficha
   BigStudio 2026

   QUE HACE
   Le agrega dos cosas a la barra de compra de Horizon:
     1. La linea de plazo ("Se agenda con 48 horas"), copiada del
        bloque de promesa que ya vive en la ficha.
     2. El precio dentro del boton, para que diga "Agregar · $12.990"
        en vez de mandar al cliente a buscar la cifra a otro lado.

   ---------------------------------------------------------------
   LO QUE NO SE PUEDE HACER AQUI, Y POR QUE

   La version anterior escribia:
       boton.textContent = boton.dataset.bhEtiqueta
   para dejar el boton con el rotulo pelado antes de colgarle el
   precio. Esa linea BORRA todos los hijos del boton, y entre esos
   hijos van dos que Horizon declara OBLIGATORIOS:

       StickyAddToCartComponent.requiredRefs =
         ["stickyBar", "addToCartButton", "quantityDisplay", "quantityNumber"]

   quantityDisplay y quantityNumber viven dentro del boton, en un
   <span style="display:none"> que solo aparece si la cantidad es
   mayor que uno. Al borrarlos, el resolvedor de refs de Horizon
   lanzaba MissingRefError, el connectedCallback moria a la mitad y
   el componente se quedaba SIN sus escuchadores.

   Consecuencia real, medida en la ficha: el boton de la barra fija
   NO agregaba al carrito. Es un <button type="button"> que no vive
   dentro de ningun formulario ni de un add-to-cart-component, asi
   que todo su comportamiento colgaba del componente que acabamos
   de matar. El cliente pulsaba y no pasaba nada.

   Y no era un fallo de una vez: Horizon vigila su propio subarbol y
   vuelve a resolver los refs ante cualquier mutacion, asi que cada
   pasada de este script relanzaba la excepcion.

   REGLA: aqui NUNCA se borra nada del boton. Solo se agrega. Si
   alguna vez hay que esconder algo que Horizon pinta ahi dentro, se
   esconde por CSS, que no toca el arbol y por tanto no rompe refs.
   ---------------------------------------------------------------
*/
(function () {
  'use strict';

  var SEP = ' · ';

  function textoPlazo() {
    var el = document.querySelector('.bh-promesa__titulo');
    if (!el) { return ''; }
    return el.textContent.trim().replace(/\.$/, '');
  }

  function precioActual(raiz) {
    var cont = raiz.querySelector('.sticky-add-to-cart__price');
    return cont ? cont.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function enganchar(raiz) {
    var barra = raiz.querySelector('.sticky-add-to-cart__bar');
    var boton = raiz.querySelector('.sticky-add-to-cart__button');
    if (!barra || !boton) { return; }

    /* Linea de plazo, encima de la fila */
    var plazo = textoPlazo();
    if (plazo) {
      var linea = barra.querySelector('.bh-barra__plazo');
      if (!linea) {
        linea = document.createElement('span');
        linea.className = 'bh-barra__plazo';
        barra.insertBefore(linea, barra.firstChild);
      }
      if (linea.textContent !== plazo) { linea.textContent = plazo; }
    }

    /* Precio dentro del boton. Se AGREGA, nunca se reemplaza.
       Va colgado de .add-to-cart-text__content y no del boton para
       que acompanie al rotulo cuando Horizon desliza el estado
       "agregado" por encima; colgando del boton se quedaria quieto
       mientras el resto se va. */
    var precio = precioActual(raiz);
    if (!precio) { return; }

    var marca = boton.querySelector('.bh-barra__precio');
    if (!marca) {
      marca = document.createElement('span');
      marca.className = 'bh-barra__precio';
      var destino = boton.querySelector('.add-to-cart-text__content') || boton;
      destino.appendChild(marca);
    }

    var texto = SEP + precio;
    if (marca.textContent !== texto) { marca.textContent = texto; }

    raiz.setAttribute('data-bh-barra', '');
  }

  function iniciar() {
    var nodos = document.querySelectorAll('sticky-add-to-cart');
    for (var i = 0; i < nodos.length; i++) {
      (function (raiz) {
        enganchar(raiz);
        if (raiz.dataset.bhObservado === '1') { return; }
        raiz.dataset.bhObservado = '1';

        /* Horizon repinta el rotulo y el precio al cambiar de
           variante. El observador vuelve a colgar el precio, y como
           enganchar() solo escribe cuando el texto cambia de verdad,
           no se realimenta. */
        var ocupado = false;
        var obs = new MutationObserver(function () {
          if (ocupado) { return; }
          ocupado = true;
          window.requestAnimationFrame(function () {
            enganchar(raiz);
            ocupado = false;
          });
        });
        obs.observe(raiz, { childList: true, subtree: true, characterData: true });
      })(nodos[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();
